import { MESSAGE_STATUS } from 'react-easyrocket';
import { TransactionStatus } from '../types';
import { DEPOSIT_PREV_PATH_LS_KEY } from '../config';

export const withdrawalStatusMap: Record<
  TransactionStatus,
  { text: string; status: MESSAGE_STATUS }
> = {
  success: { text: 'messagesWithdraw.success', status: MESSAGE_STATUS.SUCCESS },
  return: { text: 'messagesWithdraw.return', status: MESSAGE_STATUS.INFO },
  failure: { text: 'messagesWithdraw.failer', status: MESSAGE_STATUS.ERROR },
  cancel: { text: 'messagesWithdraw.cancel', status: MESSAGE_STATUS.ERROR }
};

export const depositStatusMap: Record<
  Exclude<TransactionStatus, 'cancel'>,
  { text: string; status: MESSAGE_STATUS }
> = {
  success: { text: 'messagesDeposit.success', status: MESSAGE_STATUS.SUCCESS },
  return: { text: 'messagesDeposit.return', status: MESSAGE_STATUS.INFO },
  failure: { text: 'messagesDeposit.failer', status: MESSAGE_STATUS.ERROR }
};

/** Удаляет сохраненный адрес возврата после флоу платежки.
 * Вызовите эту функцию во всех местах, в которых возможна отмена
 * депозита - например на закрытие окна FormFields.
 * Также нужно вызвать при совершении редиректа на сохраненный путь
 * после возврата с платежки
 */
export function removeDepositPrevPath() {
  sessionStorage.removeItem(DEPOSIT_PREV_PATH_LS_KEY);
}

export function getDepositPrevPath() {
  return sessionStorage.getItem(DEPOSIT_PREV_PATH_LS_KEY);
}
